import CommentVotesElement from "./comment-votes-element"

/** @typedef {import('../models/comment-votes-entity').default} CommentVotesEntity */

export default class View {
  /**
   * Creates an instance of View.
   * @param {{ upvote: function(): void, downvote: function(): void }} context
   * @param {HTMLElement} htmlElement
   * @memberof View
   */
  constructor(context, htmlElement) {
    this.commentVotesElement = CommentVotesElement.fromHtmlElement(htmlElement)

    this.commentVotesElement.onUpvote(() => context.upvote())
    this.commentVotesElement.onDownvote(() => context.downvote())
  }

  /**
   * @param {{ commentVotes: CommentVotesEntity, commentId: String }} state
   * @memberof View
   */
  update(state) {
    this.commentVotesElement.apply(state.commentVotes, state.commentId)
  }
}
